import { cn, tv, VariantProps } from "@utils/tw"
import { Link } from "eddev/routing"
import { forwardRef, ReactElement, useContext } from "react"

export type ButtonProps = {
  href?: string
  target?: string
  rel?: string
  className?: string
  style?: React.CSSProperties
  outerClassName?: string
  children?: React.ReactNode
  onClick?: (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void
  onMouseOver?: (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void
  onMouseOut?: (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void
  type?: "button" | "submit" | "reset"
}

export const Button = forwardRef<HTMLDivElement, ButtonProps>((props, ref) => {
  const { type, outerClassName, ...restProps } = props
  const Element = props.href ? Link : "button"
  const elProps = props.href
    ? {
        href: props.href,
        target: props.target,
        rel: props.rel,
      }
    : {
        type: props.type ?? "button",
      }

  return (
    <div className={cn("flex wp-block-button", outerClassName)} ref={ref}>
      <Element {...restProps} {...elProps} className={cn("wp-element-button", props.className)} style={props.style}>
        <span className="">{props.children}</span>
      </Element>
    </div>
  )
})
